import 'jquery';
import 'imgix.js';

import availabilities from './blocks/availabilities';

// imgix.config.host = 'assets.imgix.net';
// imgix.config.useHttps = false;

import Alpine from 'alpinejs';

import './blocks/amenityCarousel';
import './blocks/animatedHero';
import './blocks/animatedImageGallery';
import './blocks/animatedImageGallery';
import './blocks/floorPlan';
import './blocks/hoverImageText';
import './blocks/imageGallery';
import './blocks/amenityHoverTilt';
import './blocks/videoPlayControl';
import './blocks/map';
import './blocks/sticky';
import './customCursor';
import inlineVideo from './blocks/video';

Alpine.data('availabilities', availabilities);
Alpine.data('inlineVideo', inlineVideo);

window.Alpine = Alpine;
Alpine.start();
